import { render, staticRenderFns } from "./TestRecords.vue?vue&type=template&id=17b6a8ad&scoped=true&"
import script from "./TestRecords.vue?vue&type=script&lang=js&"
export * from "./TestRecords.vue?vue&type=script&lang=js&"
import style0 from "./TestRecords.vue?vue&type=style&index=0&id=17b6a8ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b6a8ad",
  null
  
)

export default component.exports